import { Box, BoxProps } from '~/design_system'

// These margins account for the size of the checkbox and the label's left margin
const sizeToProps = {
  sm: { ml: 'calc(14px + 0.5rem)', mt: 0, textStyle: 'subtextSmall' },
  md: { ml: 'calc(16px + 0.5rem)', mt: 0, textStyle: 'subtextSmall' },
  lg: { ml: 'calc(20px + 0.5rem)', mt: 0, textStyle: 'subtext' },
  xl: { ml: 'calc(24px + 0.5rem)', mt: 0, textStyle: 'subtext' }
}

export type CheckboxSubsectionProps = {
  /** The size of the subsection. Determines the width of the left margin. */
  size?: 'sm' | 'md' | 'lg' | 'xl'
} & Omit<BoxProps, 'size'>

export const CheckboxSubsection = ({ size = 'xl', ...props }: CheckboxSubsectionProps) => (
  <Box {...sizeToProps[size]} {...props} />
)
